import { CheckCircle2, XCircle, AlertTriangle, HelpCircle } from "lucide-react";

const StatusBadge = ({ status, size = 'default' }) => {
  const getStatusConfig = (status) => {
    const statusLower = status?.toLowerCase();
    if (statusLower === 'compliant') {
      return { 
        className: 'bg-emerald-900/40 text-emerald-300 border-emerald-700', 
        icon: <CheckCircle2 className={size === 'large' ? 'w-4 h-4 mr-1.5' : 'w-3 h-3 mr-1'} />,
        label: 'Compliant'
      };
    }
    if (statusLower === 'non-compliant') {
      return { 
        className: 'bg-red-900/40 text-red-300 border-red-700', 
        icon: <XCircle className={size === 'large' ? 'w-4 h-4 mr-1.5' : 'w-3 h-3 mr-1'} />,
        label: 'Non-Compliant'
      };
    }
    if (statusLower === 'over-compliant') {
      return { 
        className: 'bg-amber-900/40 text-amber-300 border-amber-700', 
        icon: <AlertTriangle className={size === 'large' ? 'w-4 h-4 mr-1.5' : 'w-3 h-3 mr-1'} />,
        label: 'Over-Compliant'
      };
    }
    return { 
      className: 'bg-slate-700/50 text-slate-400 border-slate-600', 
      icon: <HelpCircle className={size === 'large' ? 'w-4 h-4 mr-1.5' : 'w-3 h-3 mr-1'} />,
      label: 'Not Evaluated'
    };
  };

  const config = getStatusConfig(status);
  
  return (
    <span 
      data-testid={`status-badge-${status?.toLowerCase() || 'unknown'}`}
      className={`inline-flex items-center rounded-full font-medium border ${config.className} ${
        size === 'large' ? 'px-3 py-1 text-sm' : 'px-2.5 py-0.5 text-xs'
      }`}
    >
      {config.icon}
      {config.label}
    </span>
  );
};

export default StatusBadge;
